// extracted by mini-css-extract-plugin
var _1 = "_qwbx__ijb";
var _2 = "oEJj0H9YyW";
export { _1 as "altIcon", _2 as "root" }
